<template>
  <CommonLayout header="customerHeader" footer="customerFooter">
    <b-overlay :show="overlayShow" rounded="sm">
      <div class="light-gray mh-550 shadow mb-5 mb-sm-0">
        <div class="light-gray mh-550 shadow">
          <div class="p-2 position-relative base-color shadow" id="content-area-inner" style="max-width: 852px; margin: 0 auto;">
            <h4 class="mt-2 text-center">フラワーコーディネートシート</h4>
            <div class="col-4 col-sm-4 pr-0 position-absolute" v-if="isPlannerShow"  style="top: 10px; left: 10px;">
              <b-button class="d-inline" variant="primary" @click="printEstimate"><b-icon icon="printer" font-scale="2"></b-icon></b-button>
            </div>
            <div class="position-absolute mr-3" style="top: 40px; right: 10px;">
              <span>No.</span>{{estimateData('form', 'projectNumber')}}
            </div>
            <div class="p-4">
                <div class="mb-2 text-right p-0 small" >
                  <span id="plan" class="p-0 d-inline-block" v-if="estimateData('form', 'plan')">{{estimateData('form', 'plan')}}</span>
                  <span id="plan" class="p-0 d-inline-block" v-if="estimateData('form', 'pack')">{{estimateData('form', 'pack')}}</span>
                </div>
              <div class="form-group row mb-2">
                <div class="col-sm-6 row small">
                  <!-- #55 2022/09/05 start フラワーコーディネートシートレイアウト変更 -->
                  <div class="col-3 p-0"><span>施設名</span></div>
                  <div class="col-1 p-0">：</div>
                  <div class="col-8 p-0 text-break result-input" id="bothFamilyName"> {{estimateData('form', 'facilityName')}}</div>
                  <!-- #55 2022/09/05 end -->
                </div>
                <div class="col-sm-6 row small">
                  <div class="col-4 p-0"><span>ご両家様名</span></div>
                  <div class="col-1 p-0">：</div>
                  <div class="col-7 p-0 text-break result-input" id="bothFamilyName"> {{estimateData('form', 'bothFamilyName')}} <span>ご両家様</span></div>
                </div>
                <div class="small">
                  <div class="col-12 p-0 text-break result-input" id="attendance" v-if="estimateData('form', 'attendance')"> {{estimateData('form', 'attendance')}}名 </div>
                </div>
              </div>
              <!-- #55 2022/09/05 start フラワーコーディネートシートレイアウト変更 -->

              <div class="form-group row mb-2">
                <div class="col-sm-6 row small">
                  <div class="col-3 p-0"><span>挙式日</span></div>
                  <div class="col-1 p-0">：</div>
                  <div class="col-8 p-0 text-break result-input" id="weddingDate"> {{changeDateFormat('form', 'weddingDate')}} </div>
                </div>
                <div class="col-sm-6 row small">
                  <div class="col-4 p-0"><span>前撮り日</span></div>
                  <div class="col-1 p-0">：</div>
                  <div class="col-7 p-0 text-break result-input" id="preShootDay"> {{changeDateFormat('form', 'preShootDay')}} </div>
                </div>
              </div>
              <div class="form-group row mb-2">
                <div class="col-sm-6 row small">
                  <div class="col-3 p-0"><span>挙式スタイル</span></div>
                  <div class="col-1 p-0">：</div>
                  <div class="col-8 p-0 text-break result-input" id="weddingStyle"> {{estimateData('form', 'weddingStyle')}} </div>
                </div>
                <div class="col-sm-6 row small">
                  <div class="col-4 p-0"><span>挙式時間</span></div>
                  <div class="col-1 p-0">：</div>
                  <div class="col-7 p-0 text-break result-input" id="nuptialTime"> {{estimateData('form', 'nuptialTime')}} </div>
                </div>
              </div>
              <div class="form-group row mb-2">
                <div class="col-sm-6 row small">
                  <div class="col-3 p-0"><span>披露宴会場名</span></div>
                  <div class="col-1 p-0">：</div>
                  <div class="col-8 p-0 text-break result-input" id="venue"> {{estimateData('form', 'venue')}} </div>
                </div>
                <div class="col-sm-6 row small">
                  <div class="col-4 p-0"><span>披露宴時間</span></div>
                  <div class="col-1 p-0">：</div>
                  <div class="col-7 p-0 text-break result-input" id="weddingTime"> {{estimateData('form', 'weddingTime')}} </div>
                </div>
              </div>
              <!-- #55 2022/09/05 end -->
              <div class="form-group row mb-2">
                <div class="col-sm-6 row small">
                  <div class="col-3 p-0"><span>打合せ日</span></div>
                  <div class="col-1 p-0">：</div>
                  <!-- #55 2022/09/05 start フラワーコーディネートシートレイアウト変更 -->
                  <!-- <div class="col-8 text-break result-input" id="meetingDate"> {{estimateData('form', 'meetingDate')}} </div> -->
                  <div class="col-8 p-0 text-break result-input" id="meetingDate"> {{changeDateFormat('form', 'meetingDate')}} </div>
                  <!-- #55 2022/09/05 end -->
                </div>
                <div class="col-sm-6 row small">
                  <!-- #55 2022/09/05 start フラワーコーディネートシートレイアウト変更 -->
                  <!-- <div class="col-5 p-0"><span>担当者（日比谷）</span></div> -->
                  <div class="col-4 p-0"><span>プランナー</span></div>
                  <!-- #55 2022/09/05 end -->
                  <div class="col-1 p-0">：</div>
                  <!-- #55 2022/09/05 start フラワーコーディネートシートレイアウト変更 -->
                  <!-- <div class="col-6 text-break result-input" id="planner"> {{estimateData('form', 'planner')}} </div> -->
                  <div class="col-7 p-0 text-break result-input" id="plannerName"> {{estimateData('form', 'plannerName')}} </div>
                  <!-- #55 2022/09/05 end -->
                </div>
              </div>
              <div class="form-group row mb-2">
                <div class="col-sm-6 row small">
                  <div class="col-3 p-0"><span>明細種別</span></div>
                  <div class="col-1 p-0">：</div>
                  <!-- #55 2022/09/05 start フラワーコーディネートシートレイアウト変更 -->
                  <!-- <div class="col-8 text-break result-input" id="meetingDate"> {{estimateData('form', 'meetingDate')}} </div> -->
                  <div class="col-8 p-0 text-break result-input" id="meetingType"> {{estimateData('form', 'meetingType')}} </div>
                  <!-- #55 2022/09/05 end -->
                </div>
                <div class="col-sm-6 row small">
                  <!-- #55 2022/09/05 start フラワーコーディネートシートレイアウト変更 -->
                  <!-- <div class="col-5 p-0"><span>担当者（日比谷）</span></div> -->
                  <div class="col-4 p-0"><span>担当</span></div>
                  <!-- #55 2022/09/05 end -->
                  <div class="col-1 p-0">：</div>
                  <!-- #55 2022/09/05 start フラワーコーディネートシートレイアウト変更 -->
                  <!-- <div class="col-6 text-break result-input" id="planner"> {{estimateData('form', 'planner')}} </div> -->
                  <div class="col-7 p-0 text-break result-input" id="planner"> {{estimateData('form', 'planner')}} </div>
                  <!-- #55 2022/09/05 end -->
                </div>
              </div>
            </div>
            <div class="m-0">
              <table class="table table-bordered small text-center estimate-table">
                <thead class="thead-light">
                  <tr>
                    <th style="width: 10%"></th>
                    <th style="width: 10%">中区分</th>
                    <th style="width: 5%" v-if="isPlannerShow">まとめ<br>対象</th>
                    <th style="width: 10%">商品名</th>
                    <th style="width: 7%" v-if="isPlannerPackView">パック<br>単価</th>
                    <th style="width: 7%" v-if="isPlannerPackView">パック<br>割引率</th>
                    <th style="width: 7%">商品単価<br>(税抜)</th>
                    <th style="width: 7%" v-if="isPlannerPackView">差額単価</th>
                    <th style="width: 5%">割引(%)</th>
                    <th style="width: 5%">数量</th>
                    <th style="width: 7%" v-if="isPlannerPackView">差額合計<br>(税抜)</th>
                    <th style="width: 7%" v-else>商品金額計<br>(税抜)</th>
                    <th style="width: 10%">備考</th>
                  </tr>
                </thead>
                <tbody v-if="isPlannerShow" v-for="(estimate, category) in estimateData('table')" :key="category">
                  <tr v-for="(item, index) in estimate" :key="index">
                    <td class="align-middle" :rowspan="Object.keys(estimate).length" v-if="index === 0">{{item['sectionL']}}</td>
                    <td class="text-left" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')">{{item['sectionM']}}</td>
                    <td class="text-center">{{item['compileEstimateNumber'] !== undefined ? item['compileEstimateNumber'] : ''}}</td>
                    <td class="text-left" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')">{{item['itemName']}}</td>
                    <td class="text-right" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')" v-if="isPlannerPackView">{{toCommaSeparated(item['packPrice'])}}</td>
                    <td class="text-right" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')" v-if="isPlannerPackView">{{item['packDiscount'] ? item['packDiscount'] + '%' : ''}}</td>
                    <td class="text-right" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')" v-if="isCustomerPackView && 'margin' in item && item['margin']">{{toCommaSeparated(item['margin'])}}</td>
                    <td class="text-right" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')" v-else>{{toCommaSeparated(item['itemPrice'])}}</td>
                    <td class="text-right" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')" v-if="isPlannerPackView">{{toCommaSeparated(item['margin'])}}</td>
                    <td class="text-right" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')">{{item['discount'] !== undefined && item['discount'] !== '' ? item['discount'] + '%' : ''}}</td>
                    <td class="text-right" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')">{{item['quantity']}}</td>
                    <td class="text-right" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')">{{toCommaSeparated(item['itemEstimatePriceTotal'])}}</td>
                    <td class="text-left word-pre-wrap" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')">{{item['note']}}</td>
                  </tr>
                </tbody>
                <tbody v-if="!isPlannerShow" v-for="(estimate, category) in estimateData('tableForCustomer')" :key="category">
                  <tr v-for="(item, index) in estimate" :key="index">
                    <td class="align-middle" :rowspan="Object.keys(estimate).length" v-if="index === 0">{{item['sectionL']}}</td>
                    <td class="text-left" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')">{{item['sectionM']}}</td>
                    <td class="text-left" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')">{{item['itemName']}}</td>
                    <td class="text-right" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')" v-if="isPlannerPackView">{{toCommaSeparated(item['packPrice'])}}</td>
                    <td class="text-right" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')" v-if="isPlannerPackView">{{item['packDiscount'] ? item['packDiscount'] + '%' : ''}}</td>
                    <td class="text-right" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')" v-if="isCustomerPackView && 'margin' in item && item['margin']">{{toCommaSeparated(item['margin'])}}</td>
                    <td class="text-right" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')" v-else>{{toCommaSeparated(item['itemPrice'])}}</td>
                    <td class="text-right" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')" v-if="isPlannerPackView">{{toCommaSeparated(item['margin'])}}</td>
                    <td class="text-right" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')">{{item['discount'] !== undefined && item['discount'] !== '' ? item['discount'] + '%' : ''}}</td>
                    <td class="text-right" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')">{{item['quantity']}}</td>
                    <td class="text-right" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')">{{toCommaSeparated(item['itemEstimatePriceTotal'])}}</td>
                    <td class="text-left word-pre-wrap" :style="(item['change'] === '1' ? 'background-color:#FFE4E1;' : '')">{{item['note']}}</td>
                  </tr>
                </tbody>
                <tbody class="border-bottom">
                </tbody>
              </table>
            </div>
            <div class="row mt-3 pt-3 pl-3">
              <div class="col-12 row" v-if="isPlannerShow && estimateData('form', 'totalPriceDisplay') && estimateData('form', 'totalPriceDisplay').includes('プランナー見積もりに表示する')">
                <div class="col-8 mt-1">
                  <div class="border-bottom col-12"></div>
                  <div class="col-12 row pr-0">
                    <span class="col-8 p-0 small">{{estimateData('form', 'pack')}}合計</span>
                    <span class="col-4 p-0 text-right mb-1 small">{{toCommaSeparated(estimateData('form', 'totalPlanPrice'))}}</span>
                  </div>
                  <div class="col-12 row pr-0">
                    <span class="col-12 small p-0 text-right mb-1">{{estimateData('form', 'planRemarks')}}</span>
                  </div>
                </div>
              </div>
              <div class="col-12 row" v-if="!isPlannerShow && estimateData('form', 'totalPriceDisplay') && estimateData('form', 'totalPriceDisplay').includes('お客様見積に表示する')">
                <div class="col-8 mt-1">
                  <div class="border-bottom col-12"></div>
                  <div class="col-12 row pr-0">
                    <span class="col-8 p-0 small">{{estimateData('form', 'pack')}}合計</span>
                    <span class="col-4 p-0 text-right mb-1 small">{{toCommaSeparated(estimateData('form', 'totalPlanPrice'))}}</span>
                  </div>
                  <div class="col-12 row pr-0">
                    <span class="col-12 small p-0 text-right mb-1">{{estimateData('form', 'planRemarks')}}</span>
                  </div>
                </div>
              </div>
              <div class="col-12 row">
                <div class="col-8 mt-1">
                  <!-- #66 2022/09/27 start 合計金額表示制御対応 -->
                  <!-- <div class="border-bottom col-12"></div> -->
                  <div class="border-bottom col-12" v-if="estimateData('form', 'totalPriceExcTaxFlag') == '1'"></div>
                  <!-- #66 2022/09/27 end -->
                  <div class="w-100"></div>
                  <!-- #66 2022/09/27 start 合計金額表示制御対応 -->
                  <!-- <div class="col-12 row pr-0"> -->
                  <div class="col-12 row pr-0" v-if="estimateData('form', 'totalPriceExcTaxFlag') == '1'">
                  <!-- #66 2022/09/27 end -->
                    <span class="col-4 p-0">合計(税抜)</span>
                    <span class="col-4"></span>
                    <span class="col-4 p-0 text-right mb-5">{{toCommaSeparated(estimateData('form', 'taxExcludeTotal'))}}</span>
                  </div>
                  <!-- #66 2022/09/27 start 合計金額表示制御対応 -->
                  <!-- <div class="border-bottom col-12"></div> -->
                  <div class="border-bottom col-12" v-if="estimateData('form', 'totalPriceExcTaxFlag') == '1'"></div>
                  <!-- #66 2022/09/27 end -->
                  <div class="w-100"></div>
                  <!-- #66 2022/09/05 start 税込金額表示制御対応 -->
                  <!-- <div class="col-12 row pr-0"> -->
                  <!-- #66 2022/09/27 start 合計金額表示制御対応 -->
                  <!-- <div class="col-12 row pr-0" v-if="estimateData('form', 'hiddenTotalPriceIncTaxFlag') != '表示しない'"> -->
                  <div class="col-12 row pr-0" v-if="estimateData('form', 'totalPriceIncTaxFlag') == '1'">
                  <!-- #66 2022/09/27 end -->
                  <!-- #66 2022/09/05 end -->
                    <span class="col-4 p-0">合計(税込)</span>
                    <span class="col-4"></span>
                    <span class="col-4 p-0 text-right mb-5">{{toCommaSeparated(estimateData('form', 'taxIncludeTotal'))}}</span>
                  </div>
                  <!-- #66 2022/09/27 start 合計金額表示制御対応 -->
                  <!-- <div class="border-bottom col-12"></div> -->
                  <div class="border-bottom col-12" v-if="estimateData('form', 'totalPriceIncTaxFlag') == '1'"></div>
                  <!-- #66 2022/09/27 end -->
                  <div class="col-12 row pr-0" v-if="estimateData('form', 'pack') && estimateData('form', 'totalPriceText') && (estimateData('form', 'totalPriceExcTaxFlag') == '1' || estimateData('form', 'totalPriceIncTaxFlag') == '1')">
                    <span class="col-12 p-0 text-right mb-5" style="font-size: 65%; color: #adadff;">{{estimateData('form', 'totalPriceText')}}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div class="pr-0 mt-2">
                    <img class="border w-100" v-if="estimateData('signImage')" :src="estimateData('signImage')"/>
                  </div>
                </div>
              </div>
              <div class="w-100"></div>
              <div class="col-4 col-sm-4 pr-0">
                <img class="border w-100" v-if="estimateData('image')" :src="estimateData('image')"/>
              </div>
              <div class="col-12 mt-3" v-if="estimateData('form', 'customerMessage')">
                <p class="mb-1">【備考欄】</p>
                <p class="border p-2 h-100 line-break">{{estimateData('form', 'customerMessage')}}</p>
              </div>
              <div class="col-12 mt-5" v-if="isPlannerShow">
                <p class="mb-1">【プランナー様伝達事項】</p>
                <p class="border p-2 h-100 line-break">{{estimateData('form', 'plannerMessage')}}</p>
              </div>
            </div>
            <div class="p-3 mt-3">
              <div v-for="(imageAndMemo, sectionL) in estimateData('imageAndMemo')" :key="sectionL">
                <p class="mb-1" v-if="sectionL === 'メインテーブル・ゲストテーブル' && (imageAndMemo['images'].length > 0 || categorizedImages[sectionL].length > 0)" >【メインテーブル・ゲストテーブル】</p>
                <div class="row">
                  <template v-if="sectionL === 'メインテーブル・ゲストテーブル'">
                    <template v-for="(imageObj, index) in imageAndMemo['images']">
                      <div class="col-4 mt-2 px-1 estimate-img-div" :key="'existing_' + index">
                        <div class="card-sqr-gray card-h-140px">
                          <img class="ar-3-2" :src="imageObj.body || imageObj"/>
                        </div>
                      </div>
                    </template>

                    <template v-for="(bookmarkImg, index) in categorizedBookmarkImages['メインテーブル・ゲストテーブル']">
                      <div class="col-4 mt-2 px-1 estimate-img-div" :key="'bookmark_spec_' + index">
                        <div class="card-sqr-gray card-h-140px">
                          <img class="ar-3-2" :src="bookmarkImg.image"/>
                        </div>
                        <div v-if="isPlannerShow" class="mb-1 small text-muted">
                          <span>ブックマーク画像</span>
                        </div>
                      </div>
                    </template>

                    <template v-for="(uploadImg, index) in categorizedImages['メインテーブル・ゲストテーブル']">
                      <div class="col-4 mt-2 px-1 estimate-img-div" :key="'upload_spec_' + index">
                        <div class="card-sqr-gray card-h-140px">
                          <img class="ar-3-2" :src="uploadImg.image"/>
                        </div>
                        <div v-if="isPlannerShow" class="mb-1 small text-muted">
                          <span>アップロード画像</span>
                        </div>
                      </div>
                    </template>
                  </template>

                  <template v-else>
                    <div class="col-4 mt-2 px-1 estimate-img-div" v-for="(imageObj, index) in getCombinedImages(sectionL)" :key="'combined_' + sectionL + '_' + index">
                      <div class="card-sqr-gray card-h-140px">
                        <img class="ar-3-2" :src="imageObj.body"/>
                      </div>
                    </div>
                  </template>

                  <template v-for="(memo, index) in imageAndMemo['memo']">
                    <div :class="sectionL !== 'メインテーブル・ゲストテーブル' && getCombinedImages(sectionL).length === 1 ? 'col-8 h-auto mt-3 mb-4' : 'col-12 mt-3 mb-4'" :key="'memo_' + index" v-if="memo">
                      <p class="mb-1 mt-3" v-if="index === 'メインテーブル'">【メインテーブルメモ】</p>
                      <p class="mb-1 mt-3" v-if="index === 'ゲストテーブル'">【ゲストテーブルメモ】</p>
                      <p class="border p-2 h-100 line-break">{{memo}}</p>
                    </div>
                  </template>
                </div>
              </div>

              <div v-if="dataReady">
                <div v-for="sectionL in displaySections" :key="sectionL">
                  <template v-if="sectionL === 'メイン提案'">
                    <p class="mb-1 mt-5" v-if="hasAnyCombinedImages('メイン提案', 'メインテーブル')">【メインテーブル】</p>
                  </template>
                  <template v-else-if="sectionL === 'ゲスト別種'">
                    <p class="mb-1 mt-5" v-if="hasAnyCombinedImages('ゲスト別種', 'ゲストテーブル')">【ゲストテーブル】</p>
                  </template>
                  <template v-else>
                    <p class="mb-1 mt-5" v-if="hasAnyCombinedImages(sectionL, sectionL)">【{{sectionL}}】</p>
                  </template>

                  <div class="row mb-4" v-if="hasAnyCombinedImages(sectionL, sectionL === 'メイン提案' ? 'メインテーブル' : sectionL === 'ゲスト別種' ? 'ゲストテーブル' : sectionL)">
                    <template v-if="getSectionImages(sectionL)">
                      <template v-for="(imageSrc, index) in getSectionImages(sectionL)">
                        <div class="col-4 mt-2 px-1 estimate-img-div" :key="'existing_' + index" v-if="imageSrc['displayImage']">
                          <div class="card-sqr-gray card-h-140px">
                            <img class="ar-3-2" :src="imageSrc['image']"/>
                          </div>
                        </div>
                      </template>
                    </template>

                    <template v-for="(bookmarkImg, index) in getBookmarkImagesForSection(sectionL === 'メイン提案' ? 'メインテーブル' : sectionL === 'ゲスト別種' ? 'ゲストテーブル' : sectionL)">
                      <div class="col-4 mt-2 px-1 estimate-img-div" :key="'bookmark_' + index">
                        <div class="card-sqr-gray card-h-140px">
                          <img class="ar-3-2" :src="bookmarkImg.image"/>
                        </div>
                        <div v-if="isPlannerShow" class="mb-1 small text-muted">
                          <span>ブックマーク画像</span>
                        </div>
                      </div>
                    </template>

                    <template v-for="(uploadImg, index) in getUploadedImagesForSection(sectionL === 'メイン提案' ? 'メインテーブル' : sectionL === 'ゲスト別種' ? 'ゲストテーブル' : sectionL)">
                      <div class="col-4 mt-2 px-1 estimate-img-div" :key="'upload_' + index">
                        <div class="card-sqr-gray card-h-140px">
                          <img class="ar-3-2" :src="uploadImg.image"/>
                        </div>
                        <div v-if="isPlannerShow" class="mb-1 small text-muted">
                          <span>アップロード画像</span>
                        </div>
                      </div>
                    </template>
                  </div>
                  <template v-if="getSectionMemo(sectionL)">
                    <template v-for="(memo, index) in getSectionMemo(sectionL)">
                      <div class="col-9 h-auto mt-2 pl-0" :key="'memo_' + index" v-if="memo">
                        <p class="mb-1">【{{sectionL}}メモ】</p>
                        <p class="border p-2 h-100 line-break">{{memo}}</p>
                      </div>
                    </template>
                  </template>
                </div>

                <div v-if="categorizedBookmarkImages['未分類'] && categorizedBookmarkImages['未分類'].length > 0">
                  <p class="mb-1 mt-5">【ブックマーク画像】</p>
                  <div class="row mb-4">
                    <template v-for="(bookmarkImg, index) in categorizedBookmarkImages['未分類']">
                      <div class="col-4 mt-2 px-1 estimate-img-div" :key="'uncategorized_bookmark_' + index">
                        <div class="image-container" style="position: relative;">
                          <img class="ar-3-2 w-100" :src="bookmarkImg.image" style="border: 1px solid #dee2e6; border-radius: 0.25rem;"/>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>

                <div v-if="categorizedImages['未分類'] && categorizedImages['未分類'].length > 0">
                  <p class="mb-1 mt-5">【アップロード画像】</p>
                  <div class="row mb-4">
                    <template v-for="(uploadImg, index) in categorizedImages['未分類']">
                      <div class="col-4 mt-2 px-1 estimate-img-div" :key="'uncategorized_' + index">
                        <div class="card-sqr-gray card-h-140px">
                          <img class="ar-3-2" :src="uploadImg.image"/>
                        </div>
                      </div>
                    </template>
                    <template v-if="getSectionMemo('お客様画像')">
                      <template v-for="(memo, index) in getSectionMemo('お客様画像')">
                        <div class="col-9 h-auto mt-2" :key="'memo_' + index" v-if="memo">
                          <p class="mb-1">【アップロード画像メモ】</p>
                          <p class="border p-2 h-100 line-break">{{memo}}</p>
                        </div>
                      </template>
                    </template>
                  </div>
                </div>

                <div v-if="otherEstimateData('imageAndMemo') && otherEstimateData('imageAndMemo')['変更履歴']">
                  <template v-for="(info, index) in otherEstimateData('imageAndMemo')['変更履歴']['changeHistoryInfo']">
                    <div class="row mb-4" v-if="info['images'] && info['images'].length > 0" :key="index">
                      <template v-for="(imageSrc, imgIndex) in info['images']">
                        <div class="col-12 mt-2 px-1 estimate-img-div" :key="'image_' + imgIndex">
                          <div class="card-sqr-gray card-h-140px">
                            <img class="ar-3-2" :src="imageSrc['image']"/>
                          </div>
                        </div>
                      </template>
                      <div class="col-9 h-auto mt-2" :key="'comment_' + index" v-if="info['comment']">
                        <p class="border p-2 h-100 line-break">{{info['comment']}}</p>
                      </div>
                    </div>
                  </template>
                </div>

              </div>
              <div v-else>
                <b-overlay class="m-5" :show="!overlayShow" rounded="sm"></b-overlay>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import DirectEstimateModel from '@/models/DirectEstimateModel'
import DirectEstimateOtherSectionModel from '@/models/DirectEstimateOtherSectionModel'
import DirectEstimateLoginModel from '@/models/DirectEstimateLoginModel'
import store from '@/store/model-store'
import CommonLogModel from '@/models/CommonLogModel'

export default {
  name: 'CustomerDirectEstimate',
  components: { CommonLayout, CommonModal },
  data () {
    return {
      dataReady: false,
      overlayShow: false,
      isPlannerShow: false,
      isPlannerPackView: false,
      isCustomerPackView: false,
      estimateDisplayFlag: {},
      categoryMapping: {
        'スペック': 'メインテーブル・ゲストテーブル',
        'メイン': 'メインテーブル',
        'ゲスト': 'ゲストテーブル',
        'メインオプション': 'メインオプション',
        'ゲストオプション': 'ゲストオプション',
        'コーディネート': 'コーディネート',
        '演出': '演出',
        'その他': 'その他装飾',
        '贈呈': '贈呈',
        '挙式': '挙式関係',
        'ブーケ': 'ブーケ',
        'アフター': 'アフターブーケ'
      },
      displaySections: [
        'メイン提案',
        'ゲスト別種',
        'メインオプション',
        'ゲストオプション',
        'コーディネート',
        '演出',
        'その他装飾',
        '贈呈',
        '挙式関係',
        'ブーケ',
        'アフターブーケ'
      ],
      categorizedImages: {
        'メインテーブル・ゲストテーブル': [],
        'メインテーブル': [],
        'ゲストテーブル': [],
        'メインオプション': [],
        'ゲストオプション': [],
        'コーディネート': [],
        '演出': [],
        'その他装飾': [],
        '贈呈': [],
        '挙式関係': [],
        'ブーケ': [],
        'アフターブーケ': [],
        '未分類': []
      },
      categorizedBookmarkImages: {
        'メインテーブル・ゲストテーブル': [],
        'メインテーブル': [],
        'ゲストテーブル': [],
        'メインオプション': [],
        'ゲストオプション': [],
        'コーディネート': [],
        '演出': [],
        'その他装飾': [],
        '贈呈': [],
        '挙式関係': [],
        'ブーケ': [],
        'アフターブーケ': [],
        '未分類': []
      }
    }
  },
  methods: {
    estimateData (datatype, key = null) {
      const store = DirectEstimateModel.getStore()
      if (!store) {
        return null
      }
      return key ? store.estimate[datatype][key] : store.estimate[datatype]
    },
    otherEstimateData (datatype, key = null) {
      const store = DirectEstimateOtherSectionModel.getStore()
      if (!store) {
        return null
      }
      if (datatype === 'imageAndMemo') {
        for (const sectionL in store[datatype]) {
          for (const imageInfo in store[datatype][sectionL]['images']) {
            if (store[datatype][sectionL]['images'][imageInfo]['displayImage'] === 1) {
              this.estimateDisplayFlag[sectionL] = true
              break
            }
          }
        }
      }
      return key ? store[datatype][key] : store[datatype]
    },
    setApiData: async function (isReload = false) {
      this.overlayShow = true

      if (!this.valideProjectNumberAndPassword()) {
        this.overlayShow = false
        return false
      }

      const isLogin = await this.login(this.$route.query.projectNumber, this.$route.query.token)
      if (!isLogin) {
        this.overlayShow = false
        return false
      }
      // 受注内容とメインゲストの画像を取得
      let params = {'isPlannerShow': this.isPlannerShow}
      const resData = await DirectEstimateModel.apiSetStore(this.$bvModal, params, () => {
        this.overlayShow = false
      })
      console.log(resData)

      // パックが適用されていれば、パック表示用のフラグを立てる
      if (resData.estimate.pack) {
        if (this.isPlannerShow) {
          // プランナーやフローリスト向けのパック表示フラグを立てる
          this.isPlannerPackView = true
        } else {
          // お客様向けのパック表示フラグを立てる
          this.isCustomerPackView = true
        }
      }
      // スペック決定した商品以外の画像を繰り返し処理でカテゴリごとに取得
      params = {'isIncludeImageAndMemo': 'True'}
      try {
        // メインオプション、ゲストオプション、ゲスト別種の画像取得
        const itemInfo = []
        for (const section of ['メインテーブル', 'ゲストテーブル']) {
          // itemInfoに登録したゲスト別種のレコード番号を保持。ゲスト別種レコード番号の重複防止に利用
          const pushedMainOtherNoList = []
          const pushedGuestOtherNoList = []
          params['itemCode'] = []
          const items = resData.estimate.table[section] ? Object.keys(resData.estimate.table[section]) : []
          for (const item of items) {
            if ('mainOtherRecordNo' in resData.estimate.table[section][item]) {
              const mainOtherRecordNo = resData.estimate.table[section][item]['mainOtherRecordNo']
              const serialNo = resData.estimate.table[section][item]['serialNo']
              if (pushedMainOtherNoList.indexOf(mainOtherRecordNo + '-' + serialNo) < 0) {
                // pushedMainOtherNoListに未登録のメイン提案レコード番号の場合にitemInfoに画像取得用のパラメータをセットする
                itemInfo.push({'serialNo': serialNo, 'mainOtherRecordNo': mainOtherRecordNo, 'type': 'mainOther'})
                pushedMainOtherNoList.push(mainOtherRecordNo + '-' + serialNo)
              }
            } else if ('guestOtherRecordNo' in resData.estimate.table[section][item]) {
              const guestOtherRecordNo = resData.estimate.table[section][item]['guestOtherRecordNo']
              const serialNo = resData.estimate.table[section][item]['serialNo']
              if (pushedGuestOtherNoList.indexOf(guestOtherRecordNo + '-' + serialNo) < 0) {
                // pushedGuestOtherNoListに未登録のゲスト別種レコード番号の場合にitemInfoに画像取得用のパラメータをセットする
                itemInfo.push({'serialNo': serialNo, 'guestOtherRecordNo': guestOtherRecordNo, 'type': 'guestOther'})
                pushedGuestOtherNoList.push(guestOtherRecordNo + '-' + serialNo)
              }
            } else if (resData.estimate.table[section][item]['sectionM'] === 'メインオプション' && !('specOptionProduct' in resData.estimate.table[section][item])) {
              itemInfo.push({'serialNo': resData.estimate.table[section][item]['serialNo'], 'itemCode': resData.estimate.table[section][item]['itemCode'], 'type': 'mainOpt'})
            } else if (resData.estimate.table[section][item]['sectionM'] === 'ゲストオプション' && !('specOptionProduct' in resData.estimate.table[section][item])) {
              itemInfo.push({'serialNo': resData.estimate.table[section][item]['serialNo'], 'itemCode': resData.estimate.table[section][item]['itemCode'], 'type': 'guestOpt'})
            }
          }
        }
        if (itemInfo.length) {
          params['sectionL'] = 'メインゲストオプション別種'
          params['itemInfo'] = itemInfo
          console.log('itemInfo ↓')
          console.log(itemInfo)
          let startFlag = true
          let result = ''
          params['startNo'] = 0
          params['functionStartNo'] = 1
          let modelStore = store.getters.model
          if ('otherEstimate' in modelStore) {
            modelStore['otherEstimate']['imageAndMemo']['メインオプション'] = {}
            modelStore['otherEstimate']['imageAndMemo']['ゲストオプション'] = {}
            modelStore['otherEstimate']['imageAndMemo']['メイン提案'] = {}
            modelStore['otherEstimate']['imageAndMemo']['ゲスト別種'] = {}
          }
          while (startFlag) {
            result = await DirectEstimateOtherSectionModel.apiSetStore(this.$bvModal, params, ['メインオプション', 'ゲストオプション', 'メイン提案', 'ゲスト別種'], () => {})
            if (params['functionStartNo'] === result['functionStartNo']) {
              params['startNo'] += result['startNo']
            } else {
              params['startNo'] = result['startNo']
            }
            params['functionStartNo'] = result['functionStartNo']
            if (result.notOverSizeFlag === true) {
              startFlag = false
            }
          }
        }

        // メインゲスト以外の商品の画像と大区分メモを取得
        let sections = Object.keys(resData.estimate.table)
        sections.push('お客様画像')
        sections.push('変更履歴')
        sections.push('ブックマーク')
        const exclusionList = ['メインテーブル', 'ゲストテーブル', '持ち帰り']
        for (const section of sections) {
          params['resData'] = []
          let sectionL = ''
          if (section !== 'お客様画像' && section !== '変更履歴' && section !== 'ブックマーク') {
            let data = resData.estimate.table[section]
            for (const i in data) {
              params['resData'].push({'itemCode': data[i]['itemCode'], 'serialNo': data[i]['serialNo']})
            }
          }
          if (section !== 'お客様画像' && section !== '変更履歴' && section !== 'ブックマーク') {
            sectionL = resData.estimate.table[section][0]['sectionL']
          } else {
            sectionL = section
          }
          params['sectionL'] = sectionL
          if (exclusionList.indexOf(sectionL) < 0) {
            // メインゲスト以外の商品画像、大区分メモを取得（持ち帰りは画像無しのため、持ち帰り以外の場合に処理実施）
            let startFlag = true
            let result = ''
            params['startNo'] = 0
            let modelStore = store.getters.model
            if ('otherEstimate' in modelStore) {
              modelStore['otherEstimate']['imageAndMemo'][sectionL] = {}
            }
            while (startFlag) {
              params['itemInfo'] = ''
              result = await DirectEstimateOtherSectionModel.apiSetStore(this.$bvModal, params, sections, () => {})
              if (sectionL !== '変更履歴') {
                params['startNo'] += result[sectionL]['images'].length
              } else {
                params['startNo'] = result[sectionL]['startNo']
                params['imageStartNo'] = result[sectionL]['imageStartNo']
              }
              if (result.notOverSizeFlag === true) {
                startFlag = false
              }
            }
            if ((sectionL === 'お客様画像' || sectionL === 'ブックマーク') && modelStore['otherEstimate']['imageAndMemo'][sectionL]['images']) {
              modelStore['otherEstimate']['imageAndMemo'][sectionL]['images'] = this.sortBringImagesBySortOrder(
                modelStore['otherEstimate']['imageAndMemo'][sectionL]['images']
              )
            }
          }
        }
        this.categorizeUploadedImages()
        this.categorizeBookmarkImages()
      } finally {
        this.dataReady = true
      }
    },
    // フラワーコーディネートシート印刷処理
    printEstimate () {
      this.overlayShow = true
      const params = {'projectNumber': this.$route.query.projectNumber}
      DirectEstimateModel.print(this.$bvModal, params, () => {
        this.overlayShow = false
      }).then((res) => {
        console.log('printEstimate() res ↓')
        console.log(res)
        // 印刷したPDFを開く
        const url = res.filePath
        window.open(url, '_blank')
      })
    },
    // GETパラメータを取得
    valideProjectNumberAndPassword () {
      if (!this.$route.query.projectNumber) {
        this.$refs.commonModal.msgBoxOk('予期せぬエラーが発生しました')
        return false
      }

      if (!this.$route.query.token) {
        this.$refs.commonModal.msgBoxOk('予期せぬエラーが発生しました')
        return false
      }

      return [this.$route.query.projectNumber, this.$route.query.token]
    },
    // login api 認証
    login: async function (projectNumber, hashPassword) {
      const reqData = {
        projectNumber: projectNumber,
        hashPassword: hashPassword
      }

      const estimateDirectLoginModel = await DirectEstimateLoginModel.apiSetStore(this.$bvModal, reqData, null, (err) => {
        let errorMsg = 'エラーが発生しました'
        if (err.response && err.response.data && err.response.data.message) {
          errorMsg = err.response.data.message
        } else if (err.message) {
          errorMsg = err.message
        }
        this.$refs.commonModal.msgBoxOk(errorMsg)

        return false
      })

      // レスポンスが空の場合
      if (!estimateDirectLoginModel) {
        this.$refs.commonModal.msgBoxOk('ログイン処理でエラーが発生しました')

        return false
      // レスポンスにメッセージが入ってる場合
      } else if (estimateDirectLoginModel.message) {
        this.$refs.commonModal.msgBoxOk(estimateDirectLoginModel.message)

        return false
      }

      return true
    },
    toCommaSeparated (str) {
      if (str) {
        try {
          return parseInt(str, 10).toLocaleString()
        } catch (err) {
          return ''
        }
      }
      return str
    },
    changeDateFormat (datatype, key) {
      const date = this.estimateData(datatype, key)
      if (date === null || date === '') {
        return null
      }
      const dates = date.split('-')

      if (dates.length < 3) {
        // 日付データでなければそのまま出力する
        return date
      }

      const year = dates[0]
      const month = dates[1]
      const day = dates[2]

      if (month.slice(0, 1) === 0) {
        month.slice(1)
      }
      if (day.slice(0, 1) === 0) {
        day.slice(1)
      }
      const weekData = [ '(日)', '(月)', '(火)', '(水)', '(木)', '(金)', '(土)' ]
      const dayInfo = new Date(year, month - 1, day)
      const result = date + weekData[dayInfo.getDay()]

      return result
    },
    getCombinedImages (sectionL) {
      const combinedImages = []
      const estimateImages = this.estimateData('imageAndMemo')
      if (estimateImages && estimateImages[sectionL]) {
        const images = estimateImages[sectionL]['images'] || []
        images.forEach(img => {
          combinedImages.push({
            source: 'estimate',
            body: img['body'] || img,
            isUploadedImage: false
          })
        })
      }

      const uploadedImages = this.categorizedImages[sectionL] || []
      uploadedImages.forEach(img => {
        combinedImages.push({
          source: 'uploaded',
          body: img.image,
          isUploadedImage: true
        })
      })

      // 3. ブックマーク画像を追加
      const bookmarkImages = this.categorizedBookmarkImages[sectionL] || []
      bookmarkImages.forEach(img => {
        combinedImages.push({
          source: 'bookmark',
          body: img.image,
          category: img.originalCategory,
          name: img.name,
          isUploadedImage: false
        })
      })

      return combinedImages
    },

    getUploadedImagesForSection (sectionL) {
      let targetSection = sectionL
      if (sectionL === 'メイン提案') {
        targetSection = 'メインテーブル'
      } else if (sectionL === 'ゲスト別種') {
        targetSection = 'ゲストテーブル'
      }

      return this.categorizedImages[targetSection] || []
    },
    getBookmarkImagesForSection (sectionL) {
      try {
        // メイン提案 → メインテーブル、ゲスト別種 → ゲストテーブル の変換
        let targetSection = sectionL
        if (sectionL === 'メイン提案') {
          targetSection = 'メインテーブル'
        } else if (sectionL === 'ゲスト別種') {
          targetSection = 'ゲストテーブル'
        }

        return this.categorizedBookmarkImages[targetSection] || []
      } catch (err) {
        console.error('ブックマーク画像取得エラー:', err)
        return []
      }
    },

    getSectionImages (sectionL) {
      const otherEstimate = this.otherEstimateData('imageAndMemo')
      if (!otherEstimate || !otherEstimate[sectionL]) {
        return []
      }
      return otherEstimate[sectionL]['images'] || []
    },

    getSectionMemo (sectionL) {
      const otherEstimate = this.otherEstimateData('imageAndMemo')
      if (!otherEstimate || !otherEstimate[sectionL]) {
        return []
      }
      return otherEstimate[sectionL]['memo'] || []
    },

    hasAnyCombinedImages (otherEstimateSectionL, uploadedImageSectionL) {
      const existingImages = this.getSectionImages(otherEstimateSectionL)
      const hasExisting = existingImages.some(img => img['displayImage'] === 1)
      const hasUploaded = this.getUploadedImagesForSection(uploadedImageSectionL).length > 0
      // ブックマーク画像の存在チェック
      const hasBookmark = this.getBookmarkImagesForSection(uploadedImageSectionL).length > 0

      return hasExisting || hasUploaded || hasBookmark
    },
    categorizeUploadedImages () {
      // 初期化
      this.categorizedImages = {
        'メインテーブル・ゲストテーブル': [],
        'メインテーブル': [],
        'ゲストテーブル': [],
        'メインオプション': [],
        'ゲストオプション': [],
        'コーディネート': [],
        '演出': [],
        'その他装飾': [],
        '贈呈': [],
        '挙式関係': [],
        'ブーケ': [],
        'アフターブーケ': [],
        '未分類': []
      }
      const otherEstimate = this.otherEstimateData('imageAndMemo')
      if (!otherEstimate || !otherEstimate['お客様画像']) return
      const uploadedImages = otherEstimate['お客様画像']['images'] || []
      uploadedImages.forEach(img => {
        // 表示対象のみ
        if (img.displayImage !== 1) return
        const category = (img.category || '').trim()
        if (!category) {
          this.categorizedImages['未分類'].push({ ...img, originalCategory: '', mappedFrom: '未分類' })
          return
        }
        const categories = category.split(',').map(c => c.trim()).filter(Boolean)
        if (categories.length === 0) {
          this.categorizedImages['未分類'].push({ ...img, originalCategory: category, mappedFrom: '未分類' })
          return
        }
        let mappedCount = 0
        categories.forEach(cat => {
          const mappedSection = this.categoryMapping[cat]
          if (mappedSection && this.categorizedImages[mappedSection]) {
            this.categorizedImages[mappedSection].push({ ...img, originalCategory: category, mappedFrom: cat })
            mappedCount++
          }
        })
        // どこにも割り当てられなければ未分類へ
        if (mappedCount === 0) {
          this.categorizedImages['未分類'].push({ ...img, originalCategory: category, mappedFrom: '未分類' })
        }
      })
    },
    categorizeBookmarkImages () {
      try {
        // 初期化
        this.categorizedBookmarkImages = {
          'メインテーブル・ゲストテーブル': [],
          'メインテーブル': [],
          'ゲストテーブル': [],
          'メインオプション': [],
          'ゲストオプション': [],
          'コーディネート': [],
          '演出': [],
          'その他装飾': [],
          '贈呈': [],
          '挙式関係': [],
          'ブーケ': [],
          'アフターブーケ': [],
          '未分類': []
        }

        const otherEstimate = this.otherEstimateData('imageAndMemo')

        if (!otherEstimate || !otherEstimate['ブックマーク']) {
          console.log('ブックマークデータなし')
          return
        }

        const bookmarkImages = otherEstimate['ブックマーク']['images'] || []
        console.log(`総画像数: ${bookmarkImages.length}`)

        bookmarkImages.forEach((img, index) => {
          // 表示対象の画像のみ処理
          if (img.displayImage !== 1) {
            console.log(`スキップ (displayImage=${img.displayImage})`)
            return
          }

          const category = img.category || ''

          if (!category || category.trim() === '') {
            this.categorizedBookmarkImages['未分類'].push({
              ...img,
              originalCategory: '',
              mappedFrom: '未分類'
            })
            console.log(`カテゴリ未設定 → "未分類" に振り分け`)
            return
          }

          // カンマ区切りで複数カテゴリに対応
          const categories = category.split(',').map(c => c.trim()).filter(c => c)

          if (categories.length === 0) {
            // 空白文字のみの場合も「未分類」へ
            this.categorizedBookmarkImages['未分類'].push({
              ...img,
              originalCategory: category,
              mappedFrom: '未分類'
            })
            console.log(`"未分類" に振り分け`)
            return
          }

          let mappedCount = 0
          // カテゴリマッピングに従って振り分け
          categories.forEach(cat => {
            const mappedSection = this.categoryMapping[cat]

            if (mappedSection && this.categorizedBookmarkImages[mappedSection]) {
              this.categorizedBookmarkImages[mappedSection].push({
                ...img,
                originalCategory: category,
                mappedFrom: cat
              })
              mappedCount++
            } else {
              console.log('未対応カテゴリー')
            }
          })
          // どのカテゴリにもマッピングされなかった場合は「未分類」へ
          if (mappedCount === 0) {
            this.categorizedBookmarkImages['未分類'].push({
              ...img,
              originalCategory: category,
              mappedFrom: '未分類'
            })
          }
        })
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {
          'timestampMs': Date.now(),
          'error': err,
          'location': 'categorizedBookmarkImages'
        }, () => {})
      }
    },
    sortBringImagesBySortOrder (images) {
      try {
        if (!images || images.length === 0) return images
        const displayImages = images.filter(img => img.displayImage === 1)
        const toOrder = (v) => {
          // null/undefined/''/'   ' を未入力扱いにする
          if (v === null || v === undefined) return 999999
          if (typeof v === 'string' && v.trim() === '') return 999999
          const n = Number(v)
          return Number.isFinite(n) ? n : 999999
        }
        displayImages.sort((a, b) => toOrder(a.sortOrder) - toOrder(b.sortOrder))
        return displayImages
      } catch (err) {
        console.error('並び順ソートエラー:', err)
        return images
      }
    }
  },
  mounted () {
    this.isPlannerShow = this.$route.query.planner === '1'
    this.setApiData()
  }
}
</script>
<style>
.word-pre-wrap{
    white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/CustomerDirectEstimate.vue